import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../../services/admin/admin.service';
import { TdLoadingService } from '@covalent/core';
import { VOTE_COMPLETED } from '../../../../services/admin/constants';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-admin-idea-completed',
  templateUrl: './admin-idea-completed.component.html',
  styleUrls: ['./admin-idea-completed.component.scss']
})
export class AdminIdeaCompletedComponent implements OnInit {
  ideas: any;
  totalIdeas: number;
  statusIds = [6, -6];
  constructor(
    private _adminService: AdminService,
    private _loadingService: TdLoadingService,
    private _snackBar:MatSnackBar
  ) {}

  ngOnInit() {
    this._fetchGrid();
  }

  private _fetchGrid(paging?) {
    this._loadingService.register();
    this._adminService
      .getIdeas({ statusIds: this.statusIds }, paging)
      .subscribe((res: any) => {
        this._loadingService.resolve();
        this.ideas = res.result.data;
        this.totalIdeas = res.result.page.total;
      },
      (err) => {
        this._loadingService.resolve();
        this._snackBar.open('დაფიქსირდა შეცდომა',null,{
          duration:2000,
          panelClass:'red-snackbar',
          horizontalPosition:"right",
          verticalPosition:"top"
        })
      });
  }

  pageEvent(e) {
    this._fetchGrid(e);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/admin-idea-completed/admin-idea-completed.component.ts